<div class="text-date-formatter">
  <label class="field-label">Display</label>
  <ng-container *ngFor="let option of dateFormatUiOptions">
    <div class="radio-container">
      <input
        class="radio-input"
        type="radio"
        name="text-date-formatter-radio"
        attr.data-test="radio-input-{{option.value}}"
        [id]="option.value"
        [value]="option.value"
        [ngModel]="format.dateFormat"
        (ngModelChange)="optionSelected(option.value)"
      />
      <label [for]="option.value" class="radio-label">
        <span>{{ option.label }}</span>
      </label>
    </div>
  </ng-container>
</div>
